import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { currencyNumberFormat } from '../../../utilities/number-format';

import Payment from '../types/payment';

import TableHead from './TableHead';

const TABLE_HEADERS = ['Date of Service', 'Reason', 'Amount', 'Applied Amount'];

interface Props {
  payments: Payment[];
}

function UnappliedPaymentsTable({ payments }: Props) {
  const emptyState = (
    <EmptyTableRow>
      <td colSpan={TABLE_HEADERS.length}>There are currently no unapplied payments.</td>
    </EmptyTableRow>
  );

  const rows = payments.map(unappliedPayment => (
    <tr key={unappliedPayment.id}>
      <TableD>{moment(unappliedPayment.date).format('MM/DD/YYYY')}</TableD>
      <TableD>{unappliedPayment.reason}</TableD>
      <TableD>{currencyNumberFormat(unappliedPayment.amountCents / 100.0)}</TableD>
      <TableD>{currencyNumberFormat(unappliedPayment.azAppliedAmountCents / 100.0)}</TableD>
    </tr>
  ));

  const isEmpty = rows.length === 0;

  return (
    <div>
      <TableComponent>
        <thead>
          <tr>
            {TABLE_HEADERS.map(header => (
              <TableHead key={header}>{header}</TableHead>
            ))}
          </tr>
        </thead>

        <TableBody>{isEmpty ? emptyState : rows}</TableBody>
      </TableComponent>
    </div>
  );
}

const TableComponent = styled.table`
  width: 100%;
  margin-top: 16px;
  border-spacing: 0px;

  th,
  td {
    white-space: nowrap;
  }

  td:nth-child(2) {
    width: 99%;
    white-space: normal;
  }
`;

const TableBody = styled.tbody`
  width: 100%;
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  font-size: 16px;
  line-height: 20px;

  td {
    border: 0.8px solid #f3e7da;
  }
`;

const EmptyTableRow = styled.tr`
  td {
    padding: 48px 0px 60px 0px;
    text-align: center;
  }
`;

const TableD = styled.td`
  padding: 10px 30px;
`;

export default UnappliedPaymentsTable;
